import { ChangeDetectorRef, Component } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DocumentMetadata } from 'src/app/utils/interfaces/new/DocumentMetadata';

export interface DisplayContentData {
  id: string;
  title: string;
  fileName: string;
  size?: number;
  contentType: string;
  date: Date;
  data: string;
  quilllessData?: string;
  dataPrint?: string;
  isPagedJSActive?: boolean;
  annexes?: {
    fileName: string;
    contentType: string;
    base64Data: string;
  }[];
  retenueEnvoiDmp?: boolean;
}

@Component({
  selector: 'app-gedviewer',
  templateUrl: './gedviewer.component.html',
  styleUrls: ['./gedviewer.component.scss']
})
export class GEDViewerComponent {

  public _data: DisplayContentData;

  constructor(protected domSanitizer: DomSanitizer) { }

  public async setData(data: DisplayContentData): Promise<void> {
    setTimeout(() => {
      this._data = data;
    }, 0);
  }

  public print(document: DisplayContentData): void { }

  public download(document: DisplayContentData): void { }

  public sanitizeUrl(url: string): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
